import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function EventTermsPage() {
  return (
    <div style={{ 
      position: 'relative', 
      zIndex: 1, 
      paddingTop: '100px',
      paddingBottom: '80px',
      minHeight: '100vh',
      background: '#0a1628',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 24px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--vvs-muted)',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'Space Grotesk',
            marginBottom: '40px',
            transition: 'color 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          <ChevronLeft size={14} /> Home
        </Link>

        <h1 style={{
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 48px)',
          textTransform: 'uppercase',
          color: '#F0F4F8',
          marginBottom: '16px',
          letterSpacing: '-0.02em',
        }}>
          Event Terms & Conditions
        </h1>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '12px', 
          color: 'var(--vvs-muted)', 
          marginBottom: '48px',
          letterSpacing: '0.1em',
        }}>
          Last updated: February 2026
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: 'var(--vvs-muted)', 
          lineHeight: 1.9,
          marginBottom: '40px',
        }}>
          These Terms & Conditions apply to all events organized by Vague Vision Sound ASBL. By purchasing a ticket or attending an event, you agree to these terms.
        </p>

        <div style={{ color: '#F0F4F8', fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', lineHeight: 1.9 }}>
          <Section number="1" title="Admission">
            <List items={[
              'A valid ticket is required for entry to all VVS events',
              'VVS reserves the right to refuse entry or remove any person from the venue',
              'Age restrictions may apply // please check event details before purchasing',
              'Tickets are non-transferable unless otherwise stated',
            ]} />
          </Section>

          <Section number="2" title="Health & Safety // Immersive Experiences">
            <p style={{ color: '#F0F4F8', marginBottom: '12px' }}>
              VVS events may include immersive audiovisual experiences with:
            </p>
            <List items={[
              'Intense strobe lighting and visual effects',
              'High-volume sound and spatial audio',
              'Enclosed or dome-based environments',
              'Fog, haze, or atmospheric effects',
            ]} />
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px' }}>
              If you have photosensitive epilepsy, claustrophobia, heart conditions, or any medical condition that may be affected by these elements, please consult a medical professional before attending. VVS is not liable for any health issues arising from participation in immersive experiences.
            </p>
          </Section>

          <Section number="3" title="Recording & Photography">
            <p style={{ color: 'var(--vvs-muted)' }}>
              Professional photography, video, or audio recording is prohibited without prior written consent from VVS. Personal photography for non-commercial use may be permitted unless otherwise stated. By attending, you consent to being photographed or recorded for promotional purposes.
            </p>
          </Section>

          <Section number="4" title="Prohibited Items">
            <List items={[
              'Weapons or dangerous objects',
              'Illegal substances',
              'Professional recording equipment (without authorization)',
              'Any item deemed hazardous by security or venue staff',
            ]} />
          </Section>

          <Section number="5" title="Liability">
            <p style={{ color: 'var(--vvs-muted)' }}>
              VVS is not responsible for loss, theft, or damage to personal belongings. Attendees are responsible for their own safety and the safety of their belongings. VVS liability is limited to the extent permitted by Belgian law.
            </p>
          </Section>

          <Section number="6" title="Refunds & Cancellation">
            <p style={{ color: 'var(--vvs-muted)' }}>
              Please refer to our <Link to="/legal/refund" style={{ color: 'var(--vvs-cyan)', textDecoration: 'none' }}>Refund Policy</Link> for information on ticket refunds, event cancellation, and postponement.
            </p>
          </Section>

          <Section number="7" title="Contact">
            <p>For event-related inquiries:</p>
            <p>contact@vaguevisionsound.com</p>
            <p style={{ marginTop: '12px' }}>Vague Vision Sound ASBL</p>
            <p>Rue du Trône 214/7, 1050 Ixelles, Brussels</p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ number, title, children }) {
  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        textTransform: 'uppercase',
        color: 'var(--vvs-cyan)',
        marginBottom: '16px',
        letterSpacing: '0.08em',
      }}>
        {number}. {title}
      </h2>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul style={{ margin: 0, paddingLeft: '20px' }}>
      {items.map((item, i) => (
        <li key={i} style={{ color: 'var(--vvs-muted)', marginBottom: '8px' }}>{item}</li>
      ))}
    </ul>
  );
}
